// Import the functions you need from the SDKs you need

import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';

// Your web app's Firebase configuration

let apiKey = process.env.VUE_APP_API_KEY
let authDomain = process.env.VUE_APP_AUTH_DOMAIN
let projectId = process.env.VUE_APP_PROJECT_ID
let storageBucket = process.env.VUE_APP_STORAGE_BUCKET
let messagingSenderId = process.env.VUE_APP_MESSAGING_SENDER_ID
let appId = process.env.VUE_APP_APP_ID
const firebaseConfig = {
  apiKey: apiKey,
  authDomain: authDomain,
  projectId: projectId,
  storageBucket: storageBucket,
  messagingSenderId: messagingSenderId,
  appId: appId
};

// Initialize Firebase
firebase.initializeApp(firebaseConfig)

// Development / automated tests only. Requires an explicit opt-in, so a production build that does
// not set VUE_APP_USE_FIREBASE_EMULATOR never points at anything but the real project.
if (process.env.VUE_APP_USE_FIREBASE_EMULATOR === 'true') {
  const host = process.env.VUE_APP_FIREBASE_EMULATOR_HOST || 'localhost:9099'
  firebase.auth().useEmulator(`http://${host}`)
  // eslint-disable-next-line no-console
  console.info(`[firebase] using local auth emulator at ${host}`)
}
